import { collect } from 'fp-ts/es6/Record';
import { sortBy } from 'fp-ts/es6/Array';
import { ord, ordNumber } from 'fp-ts/es6/Ord';
import { flow } from 'fp-ts/es6/function';
import * as NEA from 'fp-ts/es6/NonEmptyArray';

export type Pref = {
  group: string;
  name: string;
  value: number;
};

export type GroupedPref = {
  group: string;
  prefs: {
    name: string;
    value: number;
  }[];
};

export class Prefs {
  static values = [
    { group: '北海道', name: '北海道', value: 1 },
    { group: '東北', name: '宮城県', value: 4 },
    { group: '東北', name: '福島県', value: 7 },
    { group: '東北', name: '岩手県', value: 3 },
    { group: '東北', name: '青森県', value: 2 },
    { group: '東北', name: '山形県', value: 6 },
    { group: '東北', name: '秋田県', value: 5 },
    { group: '関東', name: '東京都', value: 13 },
    { group: '関東', name: '神奈川県', value: 14 },
    { group: '関東', name: '千葉県', value: 12 },
    { group: '関東', name: '埼玉県', value: 11 },
    { group: '関東', name: '茨城県', value: 8 },
    { group: '関東', name: '栃木県', value: 9 },
    { group: '関東', name: '群馬県', value: 10 },
    { group: '北陸・甲信越', name: '新潟県', value: 15 },
    { group: '北陸・甲信越', name: '長野県', value: 20 },
    { group: '北陸・甲信越', name: '石川県', value: 17 },
    { group: '北陸・甲信越', name: '山梨県', value: 19 },
    { group: '北陸・甲信越', name: '富山県', value: 16 },
    { group: '北陸・甲信越', name: '福井県', value: 18 },
    { group: '東海', name: '愛知県', value: 23 },
    { group: '東海', name: '静岡県', value: 22 },
    { group: '東海', name: '岐阜県', value: 21 },
    { group: '東海', name: '三重県', value: 24 },
    { group: '関西', name: '大阪府', value: 27 },
    { group: '関西', name: '兵庫県', value: 28 },
    { group: '関西', name: '京都府', value: 26 },
    { group: '関西', name: '滋賀県', value: 25 },
    { group: '関西', name: '奈良県', value: 29 },
    { group: '関西', name: '和歌山県', value: 30 },
    { group: '中国', name: '広島県', value: 34 },
    { group: '中国', name: '岡山県', value: 33 },
    { group: '中国', name: '山口県', value: 35 },
    { group: '中国', name: '鳥取県', value: 31 },
    { group: '中国', name: '島根県', value: 32 },
    { group: '四国', name: '徳島県', value: 36 },
    { group: '四国', name: '香川県', value: 37 },
    { group: '四国', name: '愛媛県', value: 38 },
    { group: '四国', name: '高知県', value: 39 },
    { group: '九州', name: '福岡県', value: 40 },
    { group: '九州', name: '佐賀県', value: 41 },
    { group: '九州', name: '長崎県', value: 42 },
    { group: '九州', name: '熊本県', value: 43 },
    { group: '九州', name: '大分県', value: 44 },
    { group: '九州', name: '宮崎県', value: 45 },
    { group: '九州', name: '鹿児島県', value: 46 },
    { group: '沖縄', name: '沖縄県', value: 47 },
  ] as const;

  static groupBy: (_: Pref[]) => GroupedPref[] = flow(
    NEA.groupBy((p: Pref) => p.group),
    collect((group, prefs) => ({
      group: group,
      prefs: prefs.map((c) => ({
        name: c.name,
        value: c.value,
      })),
    })),
    sortBy<GroupedPref>([ord.contramap(ordNumber, (s) => s.prefs.map((p) => p.value)[0])])
  );

  static groupedValues = (): GroupedPref[] => {
    return Prefs.groupBy([...Prefs.values]);
  };
}
